import {
  createListenerMiddleware,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

export type ErrorType = "registerUserError" | "blockUserError" | "unknown";

export interface ErrorState {
  message: string | null;
  code?: number;
  type?: ErrorType;
}

const initialState: ErrorState = {
  message: null,
  code: undefined,
  type: undefined,
};

export const errorSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    setError: (state, action: PayloadAction<ErrorState>) => {
      state.message = action.payload.message;
      state.code = action.payload.code;
      state.type = action.payload.type;
    },
    clearError: (state) => {
      state.message = null;
      state.code = undefined;
      state.type = undefined;
    },
  },
});

export const { setError, clearError } = errorSlice.actions;
export default errorSlice.reducer;

export const errorListener = createListenerMiddleware();

errorListener.startListening({
  actionCreator: setError,
  effect: async (action, listenerApi) => {
    const errType = action.payload.type;
    if (errType === "registerUserError" || errType === "blockUserError") {
      await listenerApi.delay(30_000);
      listenerApi.dispatch(clearError());
    }
  },
});
